export default __webpack_public_path__ + "static/nick-bitmoji-3f2f509b520e731706cecd92f7091c56.png";